// extracted by mini-css-extract-plugin
export default {"main-content":"A45DN","logo":"Aw4qa","home":"cCvj1"};